const QUARTERS = {
    Q1: ["January", "February", "March"],
    Q2: ["April", "May", "June"],
    Q3: ["July", "August", "September"],
    Q4: ["October", "November", "December"],
};


export const getMonthsForQuarter = (quarter: string): string[] => {
    return QUARTERS[quarter as keyof typeof QUARTERS] || [];
};